export default __webpack_public_path__ + "static/technisches-asset-und-property-management-4ffc4c28a82765f0658e14e3e3c134c6.webp";